import { Paper, styled } from "@mui/material";

const StyledFormCardItem = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export default StyledFormCardItem;
